import {useEffect, useMemo, useState} from "react";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import {InputText} from "primereact/inputtext";
import {Calendar} from "primereact/calendar";
import {InputTextarea} from "primereact/inputtextarea";
import {Dropdown} from "primereact/dropdown";
import {getTiposIncapacidad} from "./integracion";

const AgregarIncapacidadDialog = ({
                                      visible,
                                      onHide,
                                      defaultName = "",
                                      onSave,
                                      userId,  choferId,
                                  }) => {
    const [nombre, setNombre] = useState(defaultName || "");
    const [fechaInicio, setFechaInicio] = useState(null);
    const [fechaFin, setFechaFin] = useState(null);
    const [fechaTrabajar, setFechaTrabajar] = useState(null);
    const [folio, setFolio] = useState("");
    const [comentarios, setComentarios] = useState("");
    const [tiposOptions, setTiposOptions] = useState([]);
    const [tipoIncapacidad, setTipoIncapacidad] = useState(null);

    useEffect(() => {
        if (visible) {
            setNombre(defaultName || "");
            setFechaInicio(null);
            setFechaFin(null);
            setFechaTrabajar(null);
            setFolio("");
            setComentarios("");
        }
    }, [visible, defaultName]);

    useEffect(() => {
        const fetchTipos = async () => {
            try {
                const res = await getTiposIncapacidad();
                // Suponiendo que el API regresa [{ ID, NOMBRE }] o similar
                const opts = (res || []).map(t => ({
                    label: t.TIPO,
                    value: t.ID
                }));
                setTiposOptions(opts);
            } catch (e) {
                console.error('Error cargando tipos de incapacidad', e);
            }
        };
        if (visible) fetchTipos();
    }, [visible]);
    const dias = useMemo(() => {
        if (!(fechaInicio instanceof Date) || !(fechaFin instanceof Date)) return 0;
        const s = new Date(fechaInicio.getFullYear(), fechaInicio.getMonth(), fechaInicio.getDate());
        const e = new Date(fechaFin.getFullYear(), fechaFin.getMonth(), fechaFin.getDate());
        const diff = Math.round((e - s) / (1000 * 60 * 60 * 24));
        return diff >= 0 ? diff + 1 : 0;
    }, [fechaInicio, fechaFin]);

    const isValid = useMemo(() => {
        if (!(fechaInicio instanceof Date) || !(fechaFin instanceof Date) || !(fechaTrabajar instanceof Date)) return false;
        const s = new Date(fechaInicio.getFullYear(), fechaInicio.getMonth(), fechaInicio.getDate());
        const e = new Date(fechaFin.getFullYear(), fechaFin.getMonth(), fechaFin.getDate());
        const back = new Date(fechaTrabajar.getFullYear(), fechaTrabajar.getMonth(), fechaTrabajar.getDate());
        if (s > e) return false;
        if (back < e) return false;
        if (!folio || !folio.trim()) return false;
        return true;
    }, [fechaInicio, fechaFin, fechaTrabajar, folio]);

    const handleSave = async () => {
        if (!isValid) return;
        const payload = {
            NOMBRE: (nombre || "").trim(),
            FECHA_INICIO: fechaInicio,
            ID_USUARIO: userId,
            ID_CHOFER: choferId,
            FECHA_FIN: fechaFin,
            DIAS: dias,
            TIPO_INCAPACIDAD: tipoIncapacidad,
            FECHA_TRABAJAR: fechaTrabajar,
            FOLIO_INCAPACIDAD: folio.trim(),
            COMENTARIOS: (comentarios || "").trim()
        };
        await onSave?.(payload);
    };

    const footer = (
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={onHide} />
            <Button label="Guardar" icon="pi pi-check" onClick={handleSave} disabled={!isValid} />
        </div>
    );

    return (
        <Dialog
            header="Agregar incapacidad"
            visible={visible}
            modal
            style={{ width: "520px", maxWidth: "95vw" }}
            onHide={onHide}
            footer={footer}
        >
            <div className="p-fluid" style={{ display: "grid", gap: 12 }}>
                <div className="field">
                    <label>{nombre}</label>
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                    <div className="field">
                        <label>Fecha inicio</label>
                        <Calendar value={fechaInicio}
                                  onChange={(e) => setFechaInicio(e.value)} dateFormat="dd/mm/yy" showIcon />
                    </div>
                    <div className="field">
                        <label>Fecha fin</label>
                        <Calendar value={fechaFin}
                                  minDate={
                                      fechaInicio
                                          ? new Date(fechaInicio.getFullYear(), fechaInicio.getMonth(), fechaInicio.getDate())
                                          : null
                                  }
                                  onChange={(e) => setFechaFin(e.value)} dateFormat="dd/mm/yy" showIcon />
                    </div>
                </div>

                <div className="field">
                    <label>Días</label>
                    <InputText value={String(dias)} readOnly />
                </div>

                <div className="field col-12 md:col-6">
                    <label htmlFor="tipoIncapacidad">Tipo de incapacidad</label>
                    <Dropdown
                        id="tipoIncapacidad"
                        value={tipoIncapacidad}
                        options={tiposOptions}
                        onChange={(e) => setTipoIncapacidad(e.value)}
                        placeholder="Selecciona tipo"
                        showClear
                        className="p-inputtext-sm"
                    />
                </div>
                <div className="field">
                    <label>Fecha a trabajar (presentarse)</label>
                    <Calendar value={fechaTrabajar}
                              minDate={
                                  fechaFin
                                      ? new Date(fechaFin.getFullYear(), fechaFin.getMonth(), fechaFin.getDate())
                                      : (fechaInicio
                                          ? new Date(fechaInicio.getFullYear(), fechaInicio.getMonth(), fechaInicio.getDate())
                                          : null)
                              }
                              onChange={(e) => setFechaTrabajar(e.value)} dateFormat="dd/mm/yy" showIcon />
                </div>

                <div className="field">
                    <label>Folio (obligatorio)</label>
                    <InputText value={folio} onChange={(e) => setFolio(e.target.value)} placeholder="Folio de incapacidad" />
                </div>

                <div className="field">
                    <label>Comentarios (opcional)</label>
                    <InputTextarea value={comentarios} onChange={(e) => setComentarios(e.target.value)} rows={3} autoResize />
                </div>

                {!isValid && (
                    <small style={{ color: "#d32f2f" }}>
                        Verifica: folio requerido, fecha inicio ≤ fecha fin, y fecha a trabajar ≥ fecha fin.
                    </small>
                )}
            </div>
        </Dialog>
    );
};

export default AgregarIncapacidadDialog;